module.exports = __webpack_public_path__ + "img/1-2.cba5db8f.webp";